/**
 * @desc 财务事件分页
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.platDataFlow.reportPage.financialEventPage.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/reportPage/financialEventPage`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
